/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import produce from "immer";
import { call, put, takeLatest } from "redux-saga/effects";

import {
  App,
  AppsBySpecificationReq,
  getAppsBySpecification,
} from "../../../api/apiCalls";
import {
  LoadingStatus,
  usePortalStateSelector,
} from "../../../rootReducer/actions";
import { MainPageEvent } from "../../MainUi";

export enum AppsByClassificationPageEvent {
  RESET = "RESET",
  GET_APPS_BY_CLASSIFICATION_PAGE_DATA = "GET_APPS_BY_CLASSIFICATION_PAGE_DATA",
  GET_APPS_BY_CLASSIFICATION_PAGE_DATA_RESULT = "GET_APPS_BY_CLASSIFICATION_PAGE_DATA_RESULT",
  GET_APPS_BY_CLASSIFICATION_PAGE_FAIL = "GET_APPS_BY_CLASSIFICATION_PAGE_FAIL",
}

export interface GetAppsByClassificationPageAction {
  type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA;
  payload: AppsBySpecificationReq;
}

export interface ResetAppsByClassificationPage {
  type: AppsByClassificationPageEvent.RESET;
}

export interface GetAppsByClassificationPageResultsAction {
  type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA_RESULT;
  results: {
    payload: App[];
    totalPages: number;
    pageNumber: number;
    totalElements: number;
  };
}

export interface GetAppsByClassificationPageActionFail {
  type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_FAIL;
}
export type AppsByClassificationPageAction =
  | ResetAppsByClassificationPage
  | GetAppsByClassificationPageAction
  | GetAppsByClassificationPageResultsAction
  | GetAppsByClassificationPageActionFail;

export interface AppsByClassificationPageData {
  loadingStatus: LoadingStatus;
  apps: App[];
  pageNo: number;
  totalPages: number;
  totalElements: number;
}

const initialState = {
  loadingStatus: LoadingStatus.LOADING_STARTED,
  apps: [],
  pageNo: 0,
  totalPages: 0,
  totalElements: 0,
  error: false,
  notification: {
    show: false,
  },
};

export function appsByClassificationPageReducer(
  state: AppsByClassificationPageData = initialState,
  action: AppsByClassificationPageAction
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA: {
        break;
      }

      case AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA_RESULT: {
        draft.loadingStatus = LoadingStatus.LOADING_SUCCESS;
        draft.apps = draft.apps.concat(action.results.payload);
        draft.pageNo = action.results.pageNumber;
        draft.totalPages = action.results.totalPages;
        draft.totalElements = action.results.totalElements;
        //TODO set any other value to the state here
        break;
      }

      case AppsByClassificationPageEvent.RESET: {
        draft.apps = [];
        draft.loadingStatus = LoadingStatus.LOADING_STARTED;
        break;
      }

      case AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_FAIL: {
        draft.loadingStatus = LoadingStatus.LOADING_ERROR;
      }
    }
  });
}

export function useAppsByClassificationPageDataSelector(): AppsByClassificationPageData {
  return usePortalStateSelector<AppsByClassificationPageData>(
    (ev) => ev.appsByClassificationPageData
  );
}

export const appsByClassificationPageSagas = [
  getAppsByClassificationPageDataSaga,
];

function* getAppsByClassificationPageDataSaga() {
  yield takeLatest(
    AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA,
    callAppsByClassificationPageData
  );
}

const arr = ["E1008", "E1009", "E1010", "E1011", "E1012", "E1013"];

function* callAppsByClassificationPageData(
  action: GetAppsByClassificationPageAction
) {
  try {
    const { payload, statusCode, totalPages, pageNumber, totalElements } =
      yield call(getAppsBySpecification, action.payload);
    if (arr.includes(statusCode)) {
      yield put({
        type: MainPageEvent.SIGN_OUT_SUCCESS,
      });
      yield put({
        type: MainPageEvent.SHOW_NOTIFICATION,
        payload: "JWT expired",
      });
      window.location.reload();
    } else {
      yield put({
        type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA_RESULT,
        results: { payload, totalPages, pageNumber, totalElements },
      });
    }
  } catch (e) {
    console.error(e);
    yield put({
      type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_FAIL,
    });
  }
}
